import React from 'react';
import OfficePopup from 'components/Popups/OfficePopup';

import * as styles from './CityesList.module.scss';

function CitiesList({ offices }) {
  return (
    <ul className={styles.list}>
      {offices.map(office => {
        return (
          <OfficePopup
            key={office.id}
            className={styles.smallScreenItem}
            title={`${office?.city}, ${office?.country}`}
            address={office?.address}
            phone={office?.phone}
            images={office?.images}
          />
        );
      })}
    </ul>
  );
}

export default CitiesList;
